/**
 * ErrorMessageWithDebug — pattern « kid-friendly + debug inline ».
 *
 * Spec (décision UX Valentin, 2026-05-17) :
 *  - Léon (11 ans) voit un message simple en clair.
 *  - JUSTE EN DESSOUS, optionnel, le détail technique en petit/gris/mono pour
 *    qu'il puisse screenshot facilement et envoyer à Valentin.
 *
 * Utilisé dans AutopsyPage (banner COOP/COEP), MissionControlPage (chess.com
 * import error), TacticsDrillPage (API /content/tactics down), EndgameDrillPage.
 *
 * Pas de default export (CONVENTIONS §6). Tokens couleur DESIGN.md (paper-50
 * pour le message, ink-300 pour le debug).
 */

interface ErrorMessageWithDebugProps {
  message: string;
  debug?: string | undefined;
  className?: string | undefined;
}

export function ErrorMessageWithDebug({
  message,
  debug,
  className,
}: ErrorMessageWithDebugProps): JSX.Element {
  return (
    <div className={className ?? ''}>
      <p className="text-paper-50">{message}</p>
      {debug && (
        <p className="mt-1 font-mono text-[11px] text-ink-300 leading-tight">
          ↳ {debug}
        </p>
      )}
    </div>
  );
}
